import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {GeneralService} from '../../services/general.service';
import {OrderFulfilSpecificItemPage} from '../../modals/order-fulfil-specific-item/order-fulfil-specific-item.page';
import {StateManagerService} from '../../services/state-manager.service';

@Component({
    selector: 'items-order-fulfilment',
    templateUrl: './items-order-fulfilment.component.html',
    styleUrls: ['./items-order-fulfilment.component.scss'],
})
export class ItemsOrderFulfilmentComponent implements OnInit {

    @Input() document: DocumentModel;
    private detailLine: DetaillineDTOModel;

    constructor(private modalController: ModalController,
                private generalService: GeneralService,
                private stateManager: StateManagerService) {
    }

    ngOnInit() {
    }

    async equipProdModal() {
        const modal = await this.modalController.create({
            component: OrderFulfilSpecificItemPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document,
                'detailLine': this.detailLine,
                'editItem': false
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log(dataReturned.data);
                this.insertEquipment(dataReturned.data);
            }
        });

        return await modal.present();
    }

    updateContract(item: DetaillineDTOModel) {
        console.log(item);
        if (item.qty <= 0) {
            this.generalService.createToast('Product already fulfilled');
            return;
        }
        const tempDetailLine = JSON.parse(JSON.stringify(item)) as DetaillineDTOModel;
        tempDetailLine.originalDetailLine = JSON.parse(JSON.stringify(item));
        tempDetailLine.documentNumber = null;
        tempDetailLine.detailLineId = 0;
        if (item.plu) {
            console.log('qty', item.qty);
            tempDetailLine.comment = item.description;
            tempDetailLine.typ = null;
            this.document.detailLines.push(tempDetailLine);
            return;
        }
        const tempItem = this.stateManager.getCollection('equipmentdistinctpdesc').find(line => {
            return line.pdesc === item.pdesc;
        });
        /* Checks if the item is a multiple or the specific item was selected in the order
        Case positive it'll simply push the detail line to the document
        TODO Check if Package type is ok with this test */
        if (tempItem.typ === 'M' || tempItem.reg) {
            if (this.isDetailLineAdded(item, this.document.detailLines) >= 0) {
                this.generalService.createToast('Product already added');
                return;
            } else {
                tempDetailLine.overrideDescriptionNote = tempDetailLine.description;
                tempDetailLine.typ = tempItem.typ;
                this.document.detailLines.push(tempDetailLine);
            }

        } else {
            this.detailLine = JSON.parse(JSON.stringify(item)) as DetaillineDTOModel;
            this.equipProdModal();
        }
    }

    isDetailLineAdded(line: DetaillineDTOModel, lineList: DetaillineDTOModel[]) {
        for (let i = 0; i < lineList.length; i++) {
            if (lineList[i].pdesc === line.pdesc) {
                return i;
            }
        }
        return -1;
    }

    private insertEquipment(data: DetaillineDTOModel[]) {
        if (this.isDetailLineAdded(data[0], this.document.detailLines) >= 0) {
            this.document.detailLines.splice(this.isDetailLineAdded(data[0], this.document.detailLines));
        }

        console.log(this.document.detailLines);
        for (const line of data) {
            console.log(line);
            this.document.detailLines.push(line);
        }
    }

    checkFulfilment(item: DetaillineDTOModel) {
        let count = 0;
        for (const line of this.document.detailLines) {
            // tslint:disable-next-line:triple-equals
            if (item.reg) {
                if (line.pdesc == item.pdesc && line.reg == item.reg && line.plu == item.plu) {
                    count += line.qty;
                }
            } else {
                if (line.pdesc == item.pdesc && line.plu == item.plu) {
                    count += line.qty;
                }
            }

        }
        return count;
    }
}
